import styled from '@emotion/styled';
import { ifProp } from 'styled-tools';
import { breakpoints } from '~/theme';

export const Wrapper = styled.div(() => ({
    '--columns': 1,
    display: 'grid',
    gridTemplateColumns: 'repeat(var(--columns), minmax(0, 1fr))',
    gap: 'var(--gap)',

    [breakpoints.sm]: {
        '--columns': 12,
        gridTemplateRows: 'auto 1fr',
    },
}));

export const Content = styled.div(() => ({
    paddingBottom: 120,
    gridColumn: '1 / -1',
    [breakpoints.sm]: {
        gridColumn: '5 / -1',
        gridRow: '1 / 3',
    },
    [breakpoints.md]: {
        gridColumn: '4 / -1',
    },
}));

export const AlphabetContainer = styled.nav(({ theme }) => ({
    backgroundColor: theme.colors.grey10,
    zIndex: theme.zIndices.searchField,
    width: '100%',
    overflowX: 'auto',
    marginBottom: theme.space[4],
    padding: `${theme.space[4]} 0 `,
    scrollbarWidth: 'none',
    '::-webkit-scrollbar': {
        display: 'none',
    },
}));

export const Alphabet = styled.ul(() => ({
    display: 'grid',
    gap: '35px',
    gridAutoFlow: 'column',
}));

export const Filter = styled.div((props) => ({
    [breakpoints.sm]: {
        gridColumn: '1 /span 3',
    },

    [breakpoints.md]: {
        position: 'sticky',
        top: 120,
        gridColumn: '1 /span 2',
    },
}));

export const AlphabetItem = styled.li<{ missingLetter?: boolean }>(
    ({ theme }) => ({
        display: 'grid',
        gridTemplateColumns: '1fr',
        gap: theme.space[2],
        fontSize: theme.fontSizes.squirrel,
        letterSpacing: '-0.2px',
        lineHeight: theme.lineHeights.cat,
        fontWeight: theme.fontWeights.bold,
        textDecoration: 'none',

        [breakpoints.sm]: {
            'a:hover, a:focus, a:active': {
                textDecoration: 'underline',
            },
        },
    }),

    ifProp('missingLetter', ({ theme }) => ({
        color: theme.colors.grey50,
        fontWeight: theme.fontWeights.normal,
        pointerEvents: 'none',
    })),
);
